<script>
import BaseButtonDialog from '@components/BaseButtonDialog'
export default {
  components: {
    BaseButtonDialog,
  },
  data() {
    return {
      loading: false,
      loadingAddOnSms: false,
      smsAvailableVisible: true,
      smsInfo: {
        available: 500,
        usage: 0,
      },
      dialogSmsStoredValueVisible: false,
      smsPriceList :[
        {
          num: 385,
          price: 500,
          average: 1.3
        },
        {
          num: 833,
          price: 1000,
          average: 1.2
        },
        {
          num: 2609,
          price: 3000,
          average: 1.15
        },
        {
          num: 4545,
          price: 5000,
          average: 1.1
        },
      ]
    }
  },
  computed: {
    status() {
      const remaining = (this.smsInfo.available - this.smsInfo.usage)/this.smsInfo.available
      const className =
        remaining <= 0.5 ? (remaining <= 0.1 ? 'danger' : 'warning') : ''
      return this.$style[className]
    },
  },
  created() {
    this.tryToFetchSMSInfo()
  },
  methods: {
    async tryToFetchSMSInfo() {
      this.loading = true
      this.smsInfo = await this.$store.dispatch('dashboard/fetchSMSInfo')
      this.loading = false
    },
    redirectSettings(activeTab = '') {
      this.$router.push({
        name: 'settings',
        params: { activeTab },
      })
    },
  },
}
</script>

<template>
<div>
    <el-card class="box-card bg-white border-0" shadow="never">
    <div slot="header" class="header">
      <h3 class="block-title">通知相關</h3>
      <template v-can="'redirectSms'">
        <div>
          <el-button
            class="is-round"
            @click="redirectSettings('sms-record')"
          >
            <BaseIcon name="paper-plane"/>
            檢視發送記錄
          </el-button>
          <!-- <el-col :span="6">
            <el-button
              class="large-btn"
              type="primary"
              @click="redirectSettings('')"
              >前往增購簡訊方案<BaseIcon name="donate"
            /></el-button>
          </el-col> -->
            <el-button
              class="is-round"
              type="primary"
              @click="redirectSettings('notification')"
              >通知設定
            </el-button>
        </div>
      </template>
    </div>
    <el-row :gutter="24">
      <el-col v-loading="loading" :sm="12" :span="24" class="mb-2 mb-sm-0">
        <el-card :class="[$style['card-sms'], status, , { [$style.isSecondaryLight]: !smsAvailableVisible }]" @click.native="smsAvailableVisible = !smsAvailableVisible">
          <template v-if="smsAvailableVisible">
            <div class="card-sms-title">本期已發簡訊數</div>
              <div class="card-sms-count Jost">
                <div><span class="usage">{{ smsInfo.usage }}</span>/<span class="available">{{ smsInfo.available }}</span></div>
                <div class="date">{{smsInfo.startDate}} - {{smsInfo.endDate}}</div>
              </div>
          </template>
          <template v-else>
            <div class="card-sms-title">本期剩餘可發簡訊數</div>
              <div class="card-sms-count Jost">
                <div><span class="usage">{{ smsInfo.available - smsInfo.usage }}</span>/<span class="available">{{ smsInfo.available }}</span></div>
                <div class="date">{{smsInfo.startDate}} - {{smsInfo.endDate}}</div>
              </div>
          </template>
        </el-card>
      </el-col>
      <el-col v-loading="loadingAddOnSms" :sm="12" :span="24" class="mb-2 mb-sm-0">
        <el-card :class="[$style['card-sms'], [$style.isSecondaryLight]]">
          <div class="card-sms-title">
            加購簡訊數
            <el-button type="text" class="isWhite" @click="dialogSmsStoredValueVisible = true">
              <BaseIcon name="exclamation-circle" icon-style="fal"/>
            </el-button>
          </div>
          <div class="card-sms-count Jost">
            <div><span class="usage">{{smsInfo.extraAvailable}}</span></div>
          </div>
        </el-card>
    </el-col>
    </el-row>
  </el-card>
  <BaseButtonDialog 
    :only-dialog="true" 
    :title="'簡訊儲值方案'" 
    :dialog-visible.sync="dialogSmsStoredValueVisible" 
    :destroy="true" 
    :width="'550px'" 
    floating
  >
    <el-table 
      :data="smsPriceList"
      style="width: 100%"
    >
      <el-table-column
        v-slot="{ row }"
        prop="price"
        label="價格"
      >
      <span class="Jost"> NT${{row.price}}元 </span>
      </el-table-column>
      <el-table-column
        v-slot="{ row }"
        prop="num"
        label="簡訊數"
        width="100"
      >
        <span class="Jost"> {{row.num}} 則 </span>
      </el-table-column>
      <el-table-column
        prop="average"
        label="均價"
      >
        <template slot-scope="scope"> <span class="Jost">均價NT${{scope.row.average}}元/則</span></template>
      </el-table-column>

    </el-table>
    <div class="mt-4 text-muted" style="line-height: 2">
      欲儲值簡訊則數，請聯絡負責您的業務代表，或直接電話聯繫 {{ $t('APP_NAME')}} 客服為您服務（02-25316628 #604）
    </div>
    <el-link
      href="tel:0225316628" 
      class="w-100 mt-4 is-round is-button"
      >請與我聯繫
    </el-link>
  </BaseButtonDialog>
</div>
</template>
<style lang="scss" module>
.card-sms {
  background: $color-primary;
  border-radius: 8px;
  &.warning {
    background: #fbb034;
  }
  &.danger {
    background: #990000;
  }
  &.isSecondaryLight {
    background: $color-secondary-light;
  }
  :global {
    .el-card__body {
      height: 101px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: white;
      .card-sms-title {
        font-size: 10px;
      }
      .card-sms-count {
        font-size: 1rem;
        font-weight: 400;
        letter-spacing: 2px;
        display: flex;
        justify-content: space-between;
        @include max-sm {
          display: block;
        }
        .usage {
          font-size: 1.5rem;
        }
        .available {
          font-size: 1rem;
        }
        .date {
          font-size: 12px;
          align-self: flex-end;
        }
      }
    }
  }
}
</style>
